import { render } from "./ChartA.vue?vue&type=template&id=be72f7ca"
import script from "./ChartA.vue?vue&type=script&lang=ts"
export * from "./ChartA.vue?vue&type=script&lang=ts"
script.render = render

export default script